import {getCurrentYear} from '../../utils/commons'
import CanadaBest10Logo from './logo'
import {canadaBest10StylesCA} from './styles'

const baseConfig = {
  domainName: 'canadabest10' as const,
  domainType: 'maga' as const,
  siteName: 'Canada Best 10',
  logo: <CanadaBest10Logo className="size-10 shrink-0 tablet:size-8" locale="ca" />,
  favicon: '/favicons/canadabest10.png',
}

const localeConfigs = {
  ca: {
    measurementId: 'G-WYM7VGG06N',
    camelCaseUrl: 'CanadaBest10.ca',
    title: (category: string, count: string) =>
      `${count} Best ${category} ${getCurrentYear()} in CA | Trusted Reviews & Buying Guides | There's 1 Clear Winner `,
    description: (_category?: string, _count?: string) =>
      `Discover Best Products at Today's Lowest Prices, Expert reviews on 1000s of products. Our Buying Guides Help You Get The Best Products for You. Buy Now!`,
    styles: canadaBest10StylesCA,
  },
}

export const createConfig = (locale: string = 'ca') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.ca
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
